export const expenseTypes: {
  id: string;
  label: string;
  default?: boolean;
}[] = [
  { id: "EXPENSE_FUN", label: "Fun", default: true },
  { id: "EXPENSE_FOOD", label: "Food", default: true },
  { id: "EXPENSE_TRANSPORTATION", label: "Transportation", default: true },
  { id: "EXPENSE_GIFTS", label: "Gifts", default: true },
  { id: "EXPENSE_DEBT", label: "Debt", default: true },
];
